module.exports = __webpack_public_path__ + "static/media/close.b4d3d944.svg";